import { createSlice } from '@reduxjs/toolkit';
import { checkVoucherValidityAsync } from './thunks';
import { VouchersState } from './types';

export const name = 'vouchers';

const initialState: VouchersState = {
  data: [],
  status: 'idle',
};

export const slice = createSlice({
  name: name,
  initialState,
  reducers: {
    clear: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(checkVoucherValidityAsync.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(checkVoucherValidityAsync.fulfilled, (state) => {
        state.status = 'success';
      })
      .addCase(checkVoucherValidityAsync.rejected, (state) => {
        state.status = 'failed';
      });
  },
});

export const actions = slice.actions;

export default slice.reducer;
